import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../lib/utils";

export const Route = createFileRoute("/library/")({
  head: () => pageHead("page.library"),
});
